"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkQJZ4DGJR_js = require('./chunk-QJZ4DGJR.js');
var chunkUUN3IUQ2_js = require('./chunk-UUN3IUQ2.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var react = require('react');
var a = require('styled-components');
var faCircleInfo = require('@fortawesome/pro-solid-svg-icons/faCircleInfo');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var a__default = /*#__PURE__*/_interopDefaultLegacy(a);

var N=a.css`
  border: 1px solid var(--border-default);
`,A=a.css`
  box-shadow: var(--elevation-100);
`,R=a.css`
  padding: var(--spacing-regular);
`,T=a__default["default"](chunkUUN3IUQ2_js.a).attrs({spacing:"small",yAlign:"center"})`
  min-height: 40px;
  justify-content: space-between;
`,P=a__default["default"](chunkUUN3IUQ2_js.a).attrs(()=>({spacing:"small",yAlign:"center"}))`
  justify-content: space-between;
`,b=a__default["default"].h3`
  margin: 0;
  font-size: var(--title-size);
  font-weight: var(--font-weight-bold);
  color: var(--foreground-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`,x=a__default["default"](chunk2VCHSK65_js.d).attrs({size:"large",weight:"bold"})`
  color: var(--foreground-primary);
  font-size: var(--value-size);
`,v=a__default["default"].button`
  // Reset button styles
  border: none;
  margin: 0;
  padding: 0;
  background: transparent;
  -webkit-appearance: none;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`,y=a__default["default"](chunk2VCHSK65_js.d).attrs({size:"small"})`
  overflow: hidden;
  color: var(--foreground-secondary);
  text-overflow: ellipsis;
`,H=a__default["default"].div`
  --title-size: ${({$size:e})=>e==="large"?"var(--font-size-regular)":"var(--font-size-small)"};
  --text-color: var(--foreground-primary);
  --value-size: ${({$size:e})=>e==="large"?"var(--font-size-x-x-large)":"var(--font-size-x-large)"};

  border-radius: var(--border-radius-small);
  background: var(--background-level-1);
  padding: var(--spacing-x-large);
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
  outline-offset: 4px;
  outline-color: var(--border-button-focus);
  transition: background-color 0.3s ease-in-out;

  ${({$type:e})=>e==="nested"&&N}
  ${({$type:e})=>e==="section"&&A}
  ${({$size:e})=>e==="small"&&R}
  
  &[role="option"] {
    &[aria-selected='true'] {
      border: var(--border-width-small) solid var(--border-boolean-active);
      background: var(--background-info-weak);
      // We need to remove the padding from the container to avoid blinking
      // -1px is because of the difference between initial border and the selected one
      padding: calc(var(--spacing-x-large) - 1px);
    }

    &[aria-disabled='true'] {
      ${b}, ${x}, ${y} {
        color: var(--foreground-disabled);
      }

      ${chunkLXX3SSRV_js.b}, ${v} {
        color: var(--foreground-disabled);
      }
    }

    :not([aria-disabled='true']):hover {
      cursor: pointer;
    }

    :not([aria-selected='true']):not([aria-disabled='true']):hover {
      background: var(--background-selected, #f7faff);
    }
  }
`,E=a__default["default"](chunk2VCHSK65_js.d).attrs({weight:"semibold",size:"medium",colorToken:"foreground-primary",forwardedAs:"span"})``;var w=react.createContext({size:"large",disabled:!1}),L=react.forwardRef(({size:e="large",type:r="section",children:o,...i},l)=>{let d=i["aria-disabled"]===!0,u=react.useMemo(()=>({size:e,disabled:d}),[d,e]);return jsxRuntime.jsx(w.Provider,{value:u,children:jsxRuntime.jsx(H,{$size:e,$type:r,...i,ref:l,children:o})})});L.displayName="Metric";var G=({children:e,size:r="large",...o})=>{let{disabled:i}=react.useContext(w);return jsxRuntime.jsx(chunkQJZ4DGJR_js.a,{placement:"top",content:e,size:r,children:jsxRuntime.jsx(v,{...o,disabled:i,children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faCircleInfo.faCircleInfo,colorToken:"foreground-button-tertiary-default"})})})};G.displayName="MetricHeaderInfoButton";var C=()=>{let{size:e}=react.useContext(w);return jsxRuntime.jsxs("svg",{role:"img","aria-labelledby":"loading-aria",viewBox:e==="large"?"0 0 100% 72":"0 0 100% 60",width:"100%",height:e==="large"?"72px":"60px",preserveAspectRatio:"none",children:[jsxRuntime.jsx("title",{id:"loading-aria",children:"Loading"}),jsxRuntime.jsx("rect",{x:"0",y:"0",width:"100%",height:"100%",clipPath:"url(#clip-path)",style:{fill:'url("#fill")'}}),jsxRuntime.jsxs("defs",{children:[jsxRuntime.jsx("clipPath",{id:"clip-path",children:e==="large"?jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsx("rect",{width:"50%",height:"44",rx:"6"}),jsxRuntime.jsx("rect",{y:"49",width:"100%",height:"24",rx:"6"})]}):jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsx("rect",{width:"50%",height:"32",rx:"6"}),jsxRuntime.jsx("rect",{y:"36",width:"100%",height:"24",rx:"6"})]})}),jsxRuntime.jsxs("linearGradient",{id:"fill",children:[jsxRuntime.jsx("stop",{offset:"0.599964",stopColor:"#DCE4F2",stopOpacity:"1",children:jsxRuntime.jsx("animate",{attributeName:"offset",values:"-2; -2; 1",keyTimes:"0; 0.25; 1",dur:"2s",repeatCount:"indefinite"})}),jsxRuntime.jsx("stop",{offset:"1.59996",stopColor:"rgba(220, 228, 242, 0.00)",stopOpacity:"1",children:jsxRuntime.jsx("animate",{attributeName:"offset",values:"-1; -1; 2",keyTimes:"0; 0.25; 1",dur:"2s",repeatCount:"indefinite"})}),jsxRuntime.jsx("stop",{offset:"2.59996",stopColor:"#DCE4F2",stopOpacity:"1",children:jsxRuntime.jsx("animate",{attributeName:"offset",values:"0; 0; 3",keyTimes:"0; 0.25; 1",dur:"2s",repeatCount:"indefinite"})})]})]})]})};C.displayName="MetricLoadingPlaceholder";var V=({isLoading:e,description:r,children:o})=>e?jsxRuntime.jsx(C,{}):jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[jsxRuntime.jsx(P,{children:o}),r&&jsxRuntime.jsx(y,{children:r})]}),M={Root:a__default["default"](L)``,Header:T,Title:b,HeaderInfoButton:G,CurrentValue:x,Body:V,LoadingPlaceholder:C,Unit:E};var F=a__default["default"].div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-regular);

  ${M.Root} {
    flex-basis: 168px;
    min-width: 0;
    flex-shrink: 0;
    flex-grow: 1;
  }
`,D=({children:e,...r})=>jsxRuntime.jsx(F,{...r,children:e});D.displayName="MetricGroup";var U=a__default["default"](D)``;var q="Enter",J=" ";function ye(e=null,r){let[o,i]=react.useState(e);react.useEffect(()=>{i(e);},[e]);function l(n){i(n),r&&r(n);}function d(){return {role:"listbox","aria-activedescendant":o!=null?o:""}}function u(n,p=!1){return {id:n,role:"option","aria-selected":o===n,"aria-disabled":p,tabIndex:p?-1:0,onClick:()=>{p||l(n);},onKeyDown:z=>{p||(z.key===q||z.key===J)&&l(n);}}}return {currentSelected:o,setCurrentSelected:i,getInteractiveItemProps:u,getInteractiveContainerProps:d}}

exports.a = M;
exports.b = U;
exports.c = ye;
